// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\"> Other Account Related Forms </h1> <p>Find the account related form you&#39;re looking for.</p> ";
// Exports
export default code;